module.exports = "<button class=\"btn btn-primary btn-block\" routerLink=\"/findphones\" role=\"button\"> Phone Finder</button>"


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/leftsidebar/leftsidebar.component.html
// module id = ../../../../../src/app/components/leftsidebar/leftsidebar.component.html
// module chunks = main